
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

  @Component({})
  export default class ImportStudentRow extends Vue {
    @Prop({ required: true }) user: any
    highlighted: boolean = false

    get fullName () {
      return `${this.user.firstname} ${this.user.middlename || ''} ${this.user.lastname}`
    }

    @Watch('user', { deep: false, immediate: true })
    userWatcher (newVal) {
      this.highlighted = newVal.highlighted
    }

    clickedCheckbox (): void {
      this.$emit('changedHighlight', { user: this.user, bool: this.highlighted })
    }
  }
